import React, { useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import POSMain from "../pages/POSMain";
import axios from "axios";
import { apiKey } from "../config/config";

export default function POSLayout() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      navigate("/admin");
    }
  }, [navigate, user]);

  useEffect(() => {
    axios.get(`${apiKey}/api/rms/admin/settings`, {
      headers: {
        Authorization: `Bearer ${user?.token}`,
      },
    }).then((res) => {
      const favIcon = JSON.parse(res.data.filter((item) => item.type === "favicon")[0]?.value || "{}").favicon_url;
      const generalSetting = JSON.parse(res.data.filter((item) => item.type === "general")[0].value);

      window.document.querySelector("link[rel='icon'").href = favIcon;
      document.title = generalSetting.restaurant_name;
    });
  }, [user?.token]);

  return (
    <>
      <Routes>
        <Route path="/main" element={<POSMain />} />
      </Routes>
    </>
  );
}
